/**
 * HOW TO USE
 *
 * use create-content-loader to generate the desired skeleton svg:
 * https://danilowoz.com/create-content-loader/
 *
 * How it works:
 * 1) get dimensions of component to skeleton and put into create-content-loader
 * 2) use best guess estimates to mock out placements for all elements you
 *  want to show in the skeleton
 * 3) transfer this to code
 * 4) load page and check the position/size for each element
 * Adjust position in code as necessary
 * 5) rinse and repeat until you hit your desired level of pixel perfection
 */

import React from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import theme from '@sm/wds-core/dist/themes/SurveyMonkey.json';

// https://github.com/danilowoz/react-content-loader/issues/194
import InitialComponent from './InitialComponent';

export const BACKGROUND_COLOR = theme['brand-color']['color--slate'];
export const ANIMATION_COLOR = theme['brand-color']['color--slate'];

const SkeletonLoader = props => {
  const { children, ...contentLoaderProps } = props;

  return (
    <ContentLoader {...contentLoaderProps}>
      {children || <InitialComponent {...props} />}
    </ContentLoader>
  );
};

SkeletonLoader.propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
  backgroundOpacity: PropTypes.number,
  foregroundColor: PropTypes.string,
  foregroundOpacity: PropTypes.number,
  speed: PropTypes.number,
};

SkeletonLoader.defaultProps = {
  children: null,
  // background
  backgroundColor: BACKGROUND_COLOR,
  backgroundOpacity: 0.08,
  // animation
  foregroundColor: ANIMATION_COLOR,
  foregroundOpacity: 0.18,
  speed: 2,
};

export default SkeletonLoader;
